module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "onlyone-app",
      "standalone": "",
      "light": ""
    }
  }, [_c('leftside-caseone', {
    attrs: {
      "menu-list": _vm.items,
      "change-mini": _vm.$store.state.leftsideMini
    }
  }), _vm._v(" "), _c('toolbar-caseone'), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18fe283a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 757
// module chunks = 1